import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { entityWithNameSchema } from '../types';

export type GetDeviceAllQueryParams = number[];

export const createGetDeviceAllQuery = () =>
	createAuthQuery({
		params: declareParams<GetDeviceAllQueryParams>(),
		request: {
			method: 'GET',
			url: '/device/all',
			query: (ids) => (ids.length > 0 ? { accountIds: ids.map(String) } : {}),
		},
		response: {
			contract: zodContract(entityWithNameSchema.array()),
		},
	});
